import { HttpClient } from './http';

export const APIClient = new HttpClient({
    headers: {
        'Content-Type': 'application/json',
    },
});
